import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function pageProgressBar() {
	const bar = document.querySelector('.js-progress-bar');
	if (bar) {
		gsap.to(bar, {
			height: '100vh',
			ease: 'none',
			scrollTrigger: {
				trigger: document.body,
				start: 0,
				end: 'bottom bottom',
				scrub: 0.15,
			},
		});
	}
}

pageProgressBar();
